import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class GuestFilterStateService {

    passed: boolean = true;
    consider: boolean = true;
    processing: boolean = true;
    noVerification: boolean = true;

    reset(): void {
        this.resetVerificationFilter();
    }

    resetVerificationFilter(): void {
        this.passed = true;
        this.consider = true;
        this.processing = true;
        this.noVerification = true;
    }

    anyVerificationFiltersEnabled(): boolean {
        return this.passed 
            || this.consider
            || this.processing
            || this.noVerification;
    }

    allVerificationFiltersActive(): boolean {
        return this.passed
            && this.consider
            && this.processing
            && this.noVerification
    }

    isVerificationFilterActive(): boolean {
        return !this.passed
            || !this.consider
            || !this.processing
            || !this.noVerification;
    }

    isPassedFilterActive(): boolean {
        return this.passed;
    }

    isConsiderFilterActive(): boolean {
        return this.consider;
    }

    isProcessingFilterActive(): boolean {
        return this.processing;
    }

    isNoVerificationFilterActive(): boolean {
        return this.noVerification;
    }
}